export class SnapshotAccessDeniedNotificationArguments {
    'jobId';
    'resourceName';
    'resourceProviderId';
    'accessDeniedItems';
    'accessDeniedBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceProviderId",
            "baseName": "resourceProviderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accessDeniedItems",
            "baseName": "accessDeniedItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedBytes",
            "baseName": "accessDeniedBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotAccessDeniedNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
